var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 38.049,
    viewBox: "0 0 128 38.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    y1: 6.614,
    x2: -0.383,
    y2: 5.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.076,
    y1: 17.098,
    x2: -1.305,
    y2: 17.098,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.862,
    y1: 10.863,
    x2: -0.501,
    y2: 9.093,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: 13.583,
    x2: 0.421,
    y2: 12.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Badge_Google_Play",
    "data-name": "Badge \\u2014 Google Play",
    transform: "translate(0.011 -0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1593",
    "data-name": "Rectangle 1593",
    width: 128,
    height: 38,
    rx: 5,
    transform: "translate(-0.011 0.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4579",
    "data-name": "Path 4579",
    d: "M750.629,364.141a3.984,3.984,0,0,1,3.979,3.98v28.424a3.984,3.984,0,0,1-3.979,3.979H632.2a3.984,3.984,0,0,1-3.979-3.979V368.121a3.984,3.984,0,0,1,3.979-3.98H750.629m0-.757H632.2a4.751,4.751,0,0,0-4.737,4.737v28.424a4.751,4.751,0,0,0,4.737,4.737H750.629a4.751,4.751,0,0,0,4.737-4.737V368.121a4.751,4.751,0,0,0-4.737-4.737Z",
    transform: "translate(-627.46 -363.383)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4580",
    "data-name": "Path 4580",
    d: "M674.559,373.449a2.566,2.566,0,0,1-.706,1.9,2.758,2.758,0,0,1-2.088.84,2.969,2.969,0,1,1,0-5.939,2.919,2.919,0,0,1,1.166.239,2.342,2.342,0,0,1,.89.635l-.5.5a1.921,1.921,0,0,0-1.557-.675,2.271,2.271,0,1,0,1.588,3.906,1.79,1.79,0,0,0,.477-1.151h-2.064v-.683h2.754A2.35,2.35,0,0,1,674.559,373.449Z",
    transform: "translate(-629.633 -363.744)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4581",
    "data-name": "Path 4581",
    d: "M679.3,371.082h-2.589v1.8h2.335v.683h-2.335v1.8H679.3v.7h-3.319v-5.685H679.3Z",
    transform: "translate(-630.01 -363.751)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4582",
    "data-name": "Path 4582",
    d: "M682.61,376.068h-.731v-4.985h-1.588v-.7H684.2v.7H682.61Z",
    transform: "translate(-630.236 -363.751)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4583",
    "data-name": "Path 4583",
    d: "M687.4,376.068v-5.685h.73v5.685Z",
    transform: "translate(-630.61 -363.751)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4584",
    "data-name": "Path 4584",
    d: "M691.459,376.068h-.731v-4.985h-1.588v-.7h3.906v.7h-1.588Z",
    transform: "translate(-630.701 -363.751)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4585",
    "data-name": "Path 4585",
    d: "M700.791,375.326a2.952,2.952,0,0,1-4.168,0,3.071,3.071,0,0,1,0-4.215,2.94,2.94,0,0,1,4.164,0,3.061,3.061,0,0,1,0,4.211Zm-3.629-.476a2.187,2.187,0,0,0,3.089,0,2.423,2.423,0,0,0,0-3.264,2.187,2.187,0,0,0-3.089,0,2.426,2.426,0,0,0,0,3.264Z",
    transform: "translate(-631.05 -363.744)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4586",
    "data-name": "Path 4586",
    d: "M703.035,376.068v-5.685h.889l2.763,4.423h.032l-.032-1.1v-3.327h.731v5.685h-.763l-2.891-4.636h-.031l.031,1.1v3.541Z",
    transform: "translate(-631.431 -363.751)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4587",
    "data-name": "Path 4587",
    d: "M694.172,384.888a4.03,4.03,0,1,0,4.045,4.029A3.972,3.972,0,0,0,694.172,384.888Zm0,6.472a2.448,2.448,0,1,1,2.274-2.443A2.331,2.331,0,0,1,694.172,391.36Zm-8.825-6.472a4.03,4.03,0,1,0,4.045,4.029A3.972,3.972,0,0,0,685.348,384.888Zm0,6.472a2.448,2.448,0,1,1,2.275-2.443A2.331,2.331,0,0,1,685.348,391.36Zm-10.5-5.236v1.709h4.091a3.568,3.568,0,0,1-.931,2.153,4.188,4.188,0,0,1-3.16,1.252,4.549,4.549,0,0,1,0-9.1,4.36,4.36,0,0,1,3.084,1.221l1.206-1.206a5.966,5.966,0,0,0-4.29-1.724,6.259,6.259,0,1,0,0,12.516,5.722,5.722,0,0,0,4.366-1.755,5.652,5.652,0,0,0,1.481-4,5.532,5.532,0,0,0-.092-1.069Zm42.928,1.328a3.746,3.746,0,0,0-3.45-2.565,3.83,3.83,0,0,0-3.8,4.029,3.943,3.943,0,0,0,4,4.03,4.006,4.006,0,0,0,3.358-1.786l-1.373-.915a2.3,2.3,0,0,1-1.985,1.114,2.05,2.05,0,0,1-1.954-1.221l5.388-2.228Zm-5.5,1.343a2.211,2.211,0,0,1,2.106-2.351,1.56,1.56,0,0,1,1.5.856ZM707.9,392.7h1.771V380.858H707.9Zm-2.9-6.915h-.061a2.792,2.792,0,0,0-2.122-.9,4.033,4.033,0,0,0,0,8.059,2.75,2.75,0,0,0,2.122-.915H705v.58c0,1.542-.824,2.366-2.152,2.366a2.231,2.231,0,0,1-2.03-1.434l-1.541.641a3.84,3.84,0,0,0,3.572,2.382c2.076,0,3.831-1.221,3.831-4.2v-7.235H705Zm-2.029,5.571a2.451,2.451,0,0,1,0-4.884,2.462,2.462,0,0,1,0,4.884Zm23.1-10.5h-4.237V392.7H723.6v-4.488h2.469a3.684,3.684,0,1,0,0-7.357Zm.046,5.708H723.6v-4.06h2.515a2.03,2.03,0,1,1,0,4.06Zm10.926-1.7a3.32,3.32,0,0,0-3.155,1.813l1.57.656a1.675,1.675,0,0,1,1.615-.869,1.7,1.7,0,0,1,1.859,1.523v.122a3.912,3.912,0,0,0-1.844-.458c-1.691,0-3.414.929-3.414,2.667a2.737,2.737,0,0,0,2.941,2.605,2.5,2.5,0,0,0,2.256-1.158h.061v.914h1.706v-4.541C740.64,386.039,739.071,384.866,737.044,384.866Zm-.214,6.491c-.579,0-1.386-.289-1.386-1.005,0-.914,1.005-1.265,1.874-1.265a3.154,3.154,0,0,1,1.615.4A2.143,2.143,0,0,1,736.83,391.357Zm10.027-6.232-2.027,5.135h-.061l-2.1-5.135h-1.9l3.154,7.178-1.8,3.992h1.844l4.861-11.169ZM730.933,392.7H732.7V380.858h-1.768Z",
    transform: "translate(-629.617 -364.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5458",
    "data-name": "Group 5458",
    transform: "translate(9.475 6.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5132",
    "data-name": "Path 5132",
    d: "M20.411,17.534a1.9,1.9,0,0,0-.438,1.331V39.819a1.9,1.9,0,0,0,.438,1.331l.07.068L32.219,29.481V29.2L20.481,17.465Z",
    transform: "translate(-19.973 -17.158)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5133",
    "data-name": "Path 5133",
    d: "M36.811,33.829,32.9,29.915v-.277l3.914-3.914.088.051,4.636,2.634c1.324.752,1.324,1.983,0,2.735L36.9,33.778Z",
    transform: "translate(-20.652 -17.592)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5134",
    "data-name": "Path 5134",
    d: "M36.245,34l-4-4L20.435,41.809a1.542,1.542,0,0,0,1.97.058L36.245,34",
    transform: "translate(-19.997 -17.816)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5135",
    "data-name": "Path 5135",
    d: "M36.245,25.323,22.4,17.459a1.542,1.542,0,0,0-1.97.058L32.243,29.325Z",
    transform: "translate(-19.997 -17.14)",
    fill: "url(#linear-gradient-4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.b19011a2db51fbaf07fb9af0c7e02e13.svg";
export { ForwardRef as ReactComponent };